import React, { useState } from 'react';

import { log } from '../../../services/utils';

import AuthForm from '../AuthForm';
import TwoFactorForm from './TwoFactorForm';
import MethodForm from './MethodForm';

const TwoFactor = () => {
	const [ method, setMethod ] = useState();

	return (
		<div id="twoFactor">
			{ log( 'twoFactor' ) }
			<AuthForm>
				{ method
					? <TwoFactorForm
						method={ method}
						setMethod={ setMethod }
					/>
					: <MethodForm setMethod={ setMethod } />
				}
			</AuthForm>
		</div>
	);
};

export default TwoFactor;
